module.exports = __webpack_public_path__ + "static/media/logo.d619ccc0.png";